module.exports = __webpack_public_path__ + "media/eat2.ffaacc7f.mp4";